import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { getPositiveListErrorKey } from "../helpers/apiError";
import { POSITIVE_LIST_MEASURE_QUERY_KEY } from "../helpers/measureDetail";
import { POSITIVE_LIST_QUERY_KEY } from "../helpers/measureList";

const useDeletePositiveListMeasure = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (measureId) => {
            const service = PositiveListService.getInstance();

            return await service.deleteMeasure(measureId);
        },
        onSuccess: (_result, measureId) => {
            const detailKey = [POSITIVE_LIST_MEASURE_QUERY_KEY, String(measureId)];

            queryClient.cancelQueries(detailKey);
            queryClient.removeQueries(detailKey);
            queryClient.invalidateQueries([POSITIVE_LIST_QUERY_KEY, softwareId]);
            toast(t("Measure removed successfully."), { type: "success" });

            if (typeof onSuccess === "function") {
                onSuccess(measureId);
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t(getPositiveListErrorKey(error) || "An error occurred while deleting the measure."),
                { type: "error" }
            );
        },
    });
};

export default useDeletePositiveListMeasure;
